import { IMealtime } from 'src/types/mealtimes.types';
import { ISection } from 'src/types/menu.types';
import { getMealtimesCategoryIds } from '../getMealtimesCategoryIds/getMealtimesCategoryIds';

export const getTotalExcludedCategories = (mealtimes: IMealtime[], categories: ISection[]) => {
  const allMealtimesCategoryIds = getMealtimesCategoryIds(mealtimes);

  return categories.reduce((acc: number, currValue: ISection) => {
    if (currValue.parentSectionId) {
      return acc;
    }
    const isCategoryIdIncluded = Boolean(allMealtimesCategoryIds.find((id: string) => currValue.sectionId === id));

    return isCategoryIdIncluded ? acc : acc + 1;
  }, 0);
};
